import {AbstractMainPlugin} from "../../AbstractMainPlugin";
import {Item} from "../../../models/Item";
import {UiAdapterService} from "../../../services/uiAdapterService/ui-adapter.service";
import {appInjector} from "../../appInjector";
import {ObjectConfig} from "../../../models/ObjectConfig";
import {RotateObjectService} from "../../../services/rotateService/rotate-object.service";
import {CesiumAdapterService} from "../../../services/cesiumAdapter21/cesium-adapter.service";
import {ItemEvent} from "../../ItemEvent";
import {ItemManagerService} from "../../../services/itemManager/item-manager.service";


export class RotateObject extends AbstractMainPlugin {
  private uiAdapter: UiAdapterService = null;
  private rotateService: RotateObjectService = null;
  private im: ItemManagerService = null;
  private isSelected = false;
  private isVisible = true;

  // private adapter: CesiumAdapterService = null;

  constructor(item:Item) {
    super(item);
    this.uiAdapter = appInjector.get(UiAdapterService);
    this.rotateService = appInjector.get(RotateObjectService);
    this.im = appInjector.get(ItemManagerService);
    // this.adapter = appInjector.get(CesiumAdapterService);
    this.initListeners();
  }

  private initListeners() {

    this.item.getObservable('rotateParentObject').subscribe((childItem)=>{
      this.isSelected = true;
      this.item.getSubject('rotateObject').next({rotate: this.item.config.getObjectConfig().getRotation(), position: this.item.config.getObjectConfig().getPosition()});
    });

    this.uiAdapter.selectedItem$.subscribe((item)=>{
      if (item instanceof Item && item.getId() == this.item.getId() && item.config.getObjectConfig().getToolType() == ObjectConfig.TYPE_FIXED_FIGURE){
        if (item.config.isCopy){
          this.isSelected = false;
          if (parent){
            let parent = this.im.getItemById(item.config.getCopyParentId);
            parent.getObservable('rotateParentObject').next(item);
          }
        }
        else{
          this.isSelected = true;
          if (this.isVisible){
            this.item.getSubject('rotateObject').next({rotate: this.item.config.getObjectConfig().getRotation(), position: this.item.config.getObjectConfig().getPosition()});
          }
        }
      }
      else{
        this.isSelected = false;
      }

      if (!(item instanceof Item) || item.config.getObjectConfig().getToolType() != ObjectConfig.TYPE_FIXED_FIGURE){
        this.isSelected = false;
        this.rotateService.hideRotateHandler();
      }
    });

    this.item.getSubject(Item.SUBJECT_VISIBILITY).subscribe((val) => {
      this.isVisible = val;
      if (this.isSelected){
        (val) ? this.item.getSubject('rotateObject').next({rotate: this.item.config.getObjectConfig().getRotation(), position: this.item.config.getObjectConfig().getPosition()}) : this.rotateService.hideRotateHandler();
      }
    });

    this.item.config.subject.subscribe((newConfig)=>{
      if (this.isSelected){
        this.item.getSubject('rotateObject').next({rotate: newConfig.getObjectConfig().getRotation(), position: newConfig.getObjectConfig().getPosition()});
      }
    });

    this.item.config.serverUpdate.subscribe((newConfig)=>{
      if (this.isSelected) {
        this.item.getSubject('rotateObject').next({
          rotate: newConfig.getObjectConfig().getRotation(),
          position: newConfig.getObjectConfig().getPosition()
        });
      }
    });

    this.item.emitter.subscribe((event: ItemEvent)=>{
      if (this.uiAdapter.currentSelectedItem instanceof Item){
        if (event.getEventName() == 'removeObject' && this.item.getId() == this.uiAdapter.currentSelectedItem.getId()){
          this.rotateService.hideRotateHandler();
        }
      }
    });
  }
}
